import { Capacitor } from "@capacitor/core";
import { API_AUTH_URL } from "api";

export const handleDownloadReport = async (url: string) => {
  try {
    const response = await fetch(`${API_AUTH_URL}${url}`.replace('//media', '/media'), {
      method: 'GET'
    });

    if (!response.ok) {
      throw new Error('Ошибка загрузки файла');
    }

    const blob = await response.blob();

    if (Capacitor.isNativePlatform() && navigator.share) {
      const file = new File([blob], 'report.pdf', { type: 'application/pdf' });
      await navigator.share({
        files: [file],
        title: 'Отчет'
      });
    } else {
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = 'report.pdf';
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    }
  } catch (e) {
    console.error(e);
  }
};
